import React from 'react';
import Box from '@mui/material/Box';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import { useTheme } from '@mui/material/styles';

function NoNewNotificationsComponent() {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', height: 296, width: '100%', justifyContent: 'center', alignItems: 'center' }}>
      <Box
        sx={{
          width: 100,
          height: 100,
          borderRadius: '50%',
          backgroundColor: theme.palette.background.default,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <NotificationsOutlinedIcon sx={{ fontSize: 48 }} />
      </Box>
    </Box>
  );
}

export default NoNewNotificationsComponent;
